<template>
  <div>
    <p class="mt-12">
      La página a la que intentas acceder no se encuentra en nuestro servidor
    </p>
    <BaseButton class="mt-12" @click.prevent="back">
      Seguir Navegando
    </BaseButton>
  </div>
</template>

<script>
import backInErrorPages from '@/mixins/backInErrorPages'

export default {
  mixins: [backInErrorPages],
}
</script>
